module.exports = __webpack_public_path__ + "img/email-notification.c2bc1576.svg";